import { convertDateTime, errorMessage, formatDateTime, splitDateRange } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import holidayService from "services/holidayService";
import { formConvertErrorMessage } from "../../helpers/form_helper";

export const useListHoliday = (payload, onSuccess, onError) => {
  const { params, queryKey, useToDisalbeCalendar } = payload;
  return useQuery(
    [queryKey || "holiday-list", params?.page],
    () => holidayService.getHolidays(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      initialData: Object({ data: [] }),
      select: response => {
        const { data } = response;
        if (!data?.items) {
          return {
            items: [],
          };
        }
        if (useToDisalbeCalendar) {
          return {
            items:
              data?.items.map(i => {
                return convertDateTime(
                  i.from_date,
                  formatDateTime.YYYY_MM_DD,
                  "-"
                );
              }) || [],
          };
        } else {
          return {
            items: data?.items || [],
            params: params,
            totalCount: data._meta
              ? data._meta.totalCount
              : data?.items?.length,
          };
        }
      },
    }
  );
};

export const useListHolidayWithTime = (payload, onSuccess, onError) => {
  const { params, queryKey, useToDisalbeCalendar } = payload;
  return useQuery(
    [queryKey || "holiday-list", params?.page],
    () => holidayService.getHolidays(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      initialData: Object({ data: [] }),
      select: response => {
        const { data } = response;
        if (!data?.items) {
          return {
            items: [],
          };
        }
        if (useToDisalbeCalendar) {
          let result = []
          data?.items.forEach(i => {
            result = [...result, ...splitDateRange(i.from_date, i.to_date)]
          })
          
          return {
            items: result
          }

        } else {
          return {
            items: data?.items || [],
            params: params,
            totalCount: data._meta
              ? data._meta.totalCount
              : data?.items?.length,
          };
        }
      },
    }
  );
};

// Detail holiday
export const useDetailHoliday = (payload, onSuccess, onError) => {
  return useQuery(
    ["holiday", "detail", payload],
    () => holidayService.detailHoliday(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return data;
      },
    }
  );
};

// Create Holiday
export const useCreateHoliday = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["holiday"]);
  const { addToast } = useToasts();

  return useMutation(holidayService.createHoliday, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.create", {
          target: t("holiday"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.create", {
              target: t("holiday"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// Update Holiday
export const useUpdateHoliday = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["holiday"]);
  const { addToast } = useToasts();

  return useMutation(holidayService.updateHoliday, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.update", {
          target: t("holiday"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.update", {
              target: t("holiday"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// Delete Holiday
export const useDeleteHoliday = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["holiday"]);
  const { addToast } = useToasts();

  return useMutation(holidayService.deleteHoliday, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.delete", {
          target: t("holiday"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.delete", {
              target: t("holiday"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};
